

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GETCOUNTRYBYID
// GETCOUNTRYBYID
const GETCOUNTRYBYID= createAsyncThunk(
  "getCountryById/getCountryById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getCountryByIdSlice = createSlice({
  name: "getCountryByIdSlice",
  initialState: {
    getCountryById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetCountryById: (state) => {
        state.getCountryById.loading = false
        state.getCountryById.error = false
        state.getCountryById.data = []
        state.getCountryById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETCOUNTRYBYID.fulfilled, (state, action) => {
      state.getCountryById = {
        ...state.getCountryById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCOUNTRYBYID.pending, (state, action) => {
      state.getCountryById = {
        ...state.getCountryById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETCOUNTRYBYID.rejected, (state, action) => {
      state.getCountryById = {
        ...state.getCountryById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getCountryByIdAction = {
    GETCOUNTRYBYID,
};

export { getCountryByIdAction };
export default getCountryByIdSlice.reducer;
export const {setInitialStateOfgetCountryById} = getCountryByIdSlice.actions